
import Dashboard from "layouts/dashboard";
import Eleves from "layouts/eleves";
import Enseignants from "layouts/enseignants";
import Cours from "layouts/cours";
import Calendrier from "layouts/calendrier";
import Livres from "layouts/livres";
import Admins from "layouts/admins";
import Carte from "layouts/carte";
import Recherche from "layouts/recherche";
import Profil from "layouts/profil";
import Groupes from "layouts/groupes";
import GroupeForm from "layouts/groupes/GroupeForm";
import GroupeDetail from "layouts/groupes/GroupeDetail";
import EleveForm from "layouts/eleves/EleveForm";
import EleveDetail from "layouts/eleves/EleveDetail";
import Reunions from "layouts/reunions";
import ReunionForm from "layouts/reunions/ReunionForm";
import ReunionDetail from "layouts/reunions/ReunionDetail";
import EnseignantForm from "layouts/enseignants/EnseignantForm";
import EnseignantDetail from "layouts/enseignants/EnseignantDetail";
import CoursForm from "layouts/cours/CoursForm";
import CoursDetail from "layouts/cours/CoursDetail";
import LivreForm from "layouts/livres/LivreForm";
import AdminForm from "layouts/admins/AdminForm";
import SignIn from "layouts/authentication/sign-in";
import Icon from "@mui/material/Icon";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

const routes = [
  // ── MENU PRINCIPAL ──
  {
    type: "collapse",
    name: "Tableau de bord",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "Élèves",
    key: "eleves",
    icon: <Icon fontSize="small">school</Icon>,
    route: "/eleves",
    component: <Eleves />,
  },
  {
    type: "collapse",
    name: "Groupes",
    key: "groupes",
    icon: <Icon fontSize="small">groups</Icon>,
    route: "/groupes",
    component: <Groupes />,
  },
  {
    type: "collapse",
    name: "Enseignants",
    key: "enseignants",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/enseignants",
    component: <Enseignants />,
  },
  {
    type: "collapse",
    name: "Cours",
    key: "cours",
    icon: <Icon fontSize="small">menu_book</Icon>,
    route: "/cours",
    component: <Cours />,
  },
  {
    type: "collapse",
    name: "Calendrier",
    key: "calendrier",
    icon: <CalendarMonthIcon fontSize="small" />,
    route: "/calendrier",
    component: <Calendrier />,
  },
  {
    type: "collapse",
    name: "Livres & Chapitres",
    key: "livres",
    icon: <Icon fontSize="small">library_books</Icon>,
    route: "/livres",
    component: <Livres />,
  },
  {
    type: "collapse",
    name: "Administrateurs",
    key: "admins",
    icon: <Icon fontSize="small">admin_panel_settings</Icon>,
    route: "/admins",
    component: <Admins />,
  },
  {
    type: "collapse",
    name: "Vue Maps",
    key: "carte",
    icon: <Icon fontSize="small">map</Icon>,
    route: "/carte",
    component: <Carte />,
  },
  {
    type: "collapse",
    name: "Réunions",
    key: "reunions",
    icon: <Icon fontSize="small">event</Icon>,
    route: "/reunions",
    component: <Reunions />,
  },

  // ── ROUTES SANS MENU ──
  {
    key: "eleve-nouveau",
    route: "/eleves/nouveau",
    component: <EleveForm />,
  },
  {
    key: "eleve-modifier",
    route: "/eleves/:id/modifier",
    component: <EleveForm />,
  },
  {
    key: "eleve-detail",
    route: "/eleves/:id",
    component: <EleveDetail />,
  },
  {
    key: "reunion-nouveau",
    route: "/reunions/nouveau",
    component: <ReunionForm />,
  },
  {
    key: "reunion-modifier",
    route: "/reunions/:id/modifier",
    component: <ReunionForm />,
  },
  {
    key: "reunion-detail",
    route: "/reunions/:id",
    component: <ReunionDetail />,
  },
  {
    key: "enseignant-nouveau",
    route: "/enseignants/nouveau",
    component: <EnseignantForm />,
  },
  {
    key: "enseignant-modifier",
    route: "/enseignants/:id/modifier",
    component: <EnseignantForm />,
  },
  {
    key: "enseignant-detail",
    route: "/enseignants/:id",
    component: <EnseignantDetail />,
  },
  {
    key: "cours-nouveau",
    route: "/cours/nouveau",
    component: <CoursForm />,
  },
  {
    key: "cours-modifier",
    route: "/cours/:id/modifier",
    component: <CoursForm />,
  },
  {
    key: "cours-detail",
    route: "/cours/:id",
    component: <CoursDetail />,
  },
  {
    key: "livre-nouveau",
    route: "/livres/nouveau",
    component: <LivreForm />,
  },
  {
    key: "livre-modifier",
    route: "/livres/:id/modifier",
    component: <LivreForm />,
  },
  {
    key: "admin-nouveau",
    route: "/admins/nouveau",
    component: <AdminForm />,
  },
  {
    key: "admin-modifier",
    route: "/admins/:id/modifier",
    component: <AdminForm />,
  },
  {
    key: "groupe-nouveau",
    route: "/groupes/nouveau",
    component: <GroupeForm />,
  },
  {
    key: "groupe-modifier",
    route: "/groupes/:id/modifier",
    component: <GroupeForm />,
  },
  {
    key: "groupe-detail",
    route: "/groupes/:id",
    component: <GroupeDetail />,
  },
  {
    key: "recherche",
    route: "/recherche",
    component: <Recherche />,
  },
  {
    key: "profil",
    route: "/profil",
    component: <Profil />,
  },
  {
    key: "sign-in",
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
];

export default routes;